<template>
  <div class="spider-leg-pin fa-stack fa-lg" @click="onClick">
    <img :src="iconByName" :class="{ 'pin-icon': shouldDisplayPinIcon }" />
    <div v-show="!shouldDisplayPinIcon" class="spider-pin-text">
      {{ fillLevel ? `${fillLevel}%` : '–' }}
    </div>
  </div>
</template>

<script>
import config from '@/components/config'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'MapPin',
  props: {
    pinClick: { type: Function, required: true },
    spiderLeg: { type: Object, required: true },
  },
  mixins: [dateUtils],
  computed: {
    iconByLevel() {
      return config.MAPBOX_ICONS.find(icon => icon.name === `icon-${this.colorByLevel}`).icon
    },
    iconByName() {
      const name = this.shouldDisplayPinIcon ? 'icon-pin' : `icon-${this.colorByLevel}`
      return config.MAPBOX_ICONS.find(icon => icon.name === name).icon
    },
    colorByLevel() {
      if (this.fillLevel < 50 && this.fillLevel > 0) return 'green'
      else if (this.fillLevel < 76) return 'yellow'
      else if (this.fillLevel > 75) return 'red'
      return 'multi'
    },
    fillLevel() {
      return this.spiderLeg.feature.fill_level
    },
    hasOldFillLevels() {
      const measuredAt = this.spiderLeg.feature.measured_at
      return this.fillLevel && this.olderThan7Days(measuredAt)
    },
    shouldDisplayPinIcon() {
      return !this.fillLevel || this.fillLevel <= 0 || this.hasOldFillLevels
    },
  },
  methods: {
    onClick(e) {
      const colorClass = this.hasOldFillLevels ? 'level-invalid' : `level-${this.colorByLevel}`
      return this.pinClick(e, colorClass, this.spiderLeg)
    },
  },
}
</script>

<style scoped>
.pin-icon {
  width: 30px;
  height: auto;
}
</style>
